// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h4[data-v-16d7b8a7],p[data-v-16d7b8a7]{font-family:PingFangSC,PingFangSC-Regular}p[data-v-16d7b8a7]{color:#61666d;font-size:14px;text-indent:28px}h4[data-v-16d7b8a7],p[data-v-16d7b8a7]{margin-top:15px}img[data-v-16d7b8a7]{margin:15px 0}.content-subTitle[data-v-16d7b8a7]{height:22px;font-size:16px;font-weight:600;color:#2b2d42;line-height:22px;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
